<template>
  <section class="[ p-2 ]">
    <h1 class="[ text-xl font-bold ]">Multiple Call Scorecard</h1>
  </section>
  <Teleport to="[data-header-action]" v-if="isMounted">
    <div class="[ flex gap-3 ]">
      <ButtonComponent label="Create a MultiScore" outlined @click="createMultiScore">
        <template #icon>
          <JBIcon name="add" />
        </template>
      </ButtonComponent>
    </div>
  </Teleport>
  <div v-bind="$attrs" class="[ flex flex-col gap-4 max-w-5xl mx-auto ]">
  
  </div>
</template>

<script setup lang="ts">

import { Button as ButtonComponent } from 'primevue';
import JBIcon from '@/components/JBIcon.vue';
import { useMounted } from "@vueuse/core";
// import { computed, onMounted, ref } from "vue";
// import { formatRelative } from "date-fns";
// import { storeToRefs } from "pinia";
const isMounted = useMounted();
function createMultiScore() {
  // Logic to create a MultiScore
  console.log('Create a MultiScore button clicked');
}

definePage({
  meta: { title: "Multiple Call Scorecard", icon: "hierarchy-square"},
});
</script>